import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { AudienceSection } from '../components/AudienceSection';
import { SocialProofSection } from '../components/SocialProofSection';
import { OfferSection } from '../components/OfferSection';
export function LandingPage() {
  return <main className="min-h-screen bg-navy-900 font-body text-slate-200 overflow-x-hidden" data-id="element-211">
      <HeroSection data-id="element-212" />
      <ProblemSection data-id="element-213" />
      <SolutionSection data-id="element-214" />
      <AudienceSection data-id="element-215" />
      <SocialProofSection data-id="element-216" />
      <OfferSection data-id="element-217" />
    </main>;
}